if (!customElements.get("extended-offer-modal-cp")) {
  customElements.define(
    "extended-offer-modal-cp",

    class ExtendedOfferModalCP extends HTMLElement {
      constructor() {
        super();
        this.modalOpen = false;

        // this.soldoutVariants = [];
        this.payload = {};

        this.addToMailingList = false;
      }

      connectedCallback() {
        /** @type {HTMLScriptElement | null} */
        const productScriptElement = this.querySelector("script");
        if (!productScriptElement || !productScriptElement.textContent) {
          console.log("Cannot find product-element");
          return;
        }

        this.product = JSON.parse(productScriptElement.textContent);

        this.companyId = this.dataset.companyId;
        this.shopDomain = this.dataset.shopDomain;

        messenger.listen(
          messenger.topics.OPEN_CP_EXTENDED_OFFER_MODAL,
          (data) => {
            if (this.product.id !== data.product.id) {
              return;
            }
            this.incomingMessageLock = true;
            this.populatePayload(data);
            this.setVariantPreset(data);
            this.openModal();
            this.incomingMessageLock = false;
          }
        );

        this.extendedOfferButton = document.querySelector(
          "#extended-offer-button"
        );

        /** @type {HTMLButtonElement | null} */
        this.closeX = this.querySelector(".close__btn");
        /** @type {HTMLButtonElement | null} */
        this.submitButton = this.querySelector("#remind-email-auth-button");
        /** @type {HTMLInputElement | null} */
        this.subscribeCheckbox = this.querySelector("#subscribe-to-mail-list");

        if (!this.closeX || !this.submitButton || !this.subscribeCheckbox) {
          console.log("Cannot find necessary elements");
          return;
        }

        this.subscribeCheckbox.addEventListener("change", () => {
          if (!this.subscribeCheckbox) {
            console.log("Cannot find subscribeCheckbox");
            return;
          }
          this.addToMailingList = this.subscribeCheckbox.checked ? true : false;
        });

        this.submitButton.addEventListener("click", (e) => {
          e.preventDefault();
          this.addToWatchlist(this.addToMailingList);
          const form = this.querySelector("form");
          if (!form) {
            console.log("Cannot find form");
            return;
          }
          form.reset();
        });

        this.closeX.addEventListener("click", () => {
          this.closeModal();
        });

        window.addEventListener("click", (e) => {
          if (e.target == this) {
            this.closeModal();
          }
        });
      }

      closeAllOpenModals() {
        const openModals = document.querySelectorAll("extended-offer-modal-cp");
        openModals.forEach((modal) => {
          modal.classList.remove("is-visible");
        });
      }

      openModal() {
        this.closeAllOpenModals();
        // console.log("opening modal");
        this.classList.add("is-visible");

        /** @type {HTMLInputElement | null} */
        const emailAuthInput = this.querySelector("#remind-email-auth-input");
        /** @type {HTMLElement | null} */
        const emailLoading = this.querySelector("#remind-email-loading");
        /** @type {HTMLElement | null} */
        const emailSuccess = this.querySelector("#remind-email-success");
        /** @type {HTMLElement | null} */
        const emailError = this.querySelector("#remind-email-error");
        /** @type {HTMLButtonElement | null} */
        const emailAuthButton = this.querySelector("#remind-email-auth-button");

        if (!emailAuthInput || !emailLoading || !emailSuccess || !emailError || !emailAuthButton) {
          console.log("Cannot find necessary elements");
          return;
        }

        emailAuthInput.style.display = "block";
        emailLoading.style.display = "none";
        emailSuccess.style.display = "none";
        emailError.style.display = "none";
        emailAuthButton.disabled = false;

        this.modalOpen = true;
      }

      closeModal() {
        // console.log("closing modal");
        this.classList.remove("is-visible");
        this.modalOpen = false;
      }

      populatePayload(data) {
        // console.log('populating payload', data);
        const product = data.product;
        this.variant = product.variants.find((item) => {
          return item.id == data.selectedVariantId;
        });

        // const variantPriceString = variant.price.toString();

        // this.payload = {
        //   epi: variant.id,
        //   empi: product.id,
        //   du: `https://${this.shopDomain}/products/${product.handle}`,
        //   iu: variant.featured_image ? variant.featured_image.src : product.featured_image,
        //   pr: parseFloat(variantPriceString.replace(/[^0-9\.]/gi, "")),
        // };

      }


      setVariantPreset(data) {
        const variantInject = this.querySelector("#variant-inject");
        if (!variantInject) {
          console.log("Cannot find variantInject");
          return;
        }

        // clear variantInject
        while (variantInject.firstChild) {
          variantInject.removeChild(variantInject.firstChild);
        }

        if (!variantInject) {
          return;
        }

        const product = data.product;
        const currentVariant = product.variants.find((item) => {
          return item.id == data.selectedVariantId;
        });

        // if there is only one option and it is the default title, then just show the product title
        if (currentVariant.title === "Default Title") {
          let optionDiv = document.createElement("div");
          let optionPTagValue = document.createElement("p");
          optionPTagValue.setAttribute("id", `option-0`);
          optionPTagValue.setAttribute("class", "option-value");
          optionPTagValue.innerHTML = `${product.title}`;
          optionDiv.appendChild(optionPTagValue);
          variantInject.appendChild(optionDiv);
          return;
        }
        const optionNames = product.options;

        // delete all child elements of variantInject
        while (variantInject.firstChild) {
          variantInject.removeChild(variantInject.firstChild);
        }

        for (let i = 0; i < optionNames.length; i++) {
          let optionName = optionNames[i];
          let optionValue = currentVariant[`option${i + 1}`];
          let optionDiv = document.createElement("div");

          let optionPTagKey = document.createElement("p");
          optionPTagKey.setAttribute("class", "option-key");
          optionPTagKey.innerHTML = `${optionName}:`;

          let optionPTagValue = document.createElement("p");
          optionPTagValue.setAttribute("id", `option-${i}`);
          optionPTagValue.setAttribute("class", "option-value");
          optionPTagValue.innerHTML = `${optionValue}`;

          optionDiv.appendChild(optionPTagKey);
          optionDiv.appendChild(optionPTagValue);
          variantInject.appendChild(optionDiv);
        }
      }


      /** @param {boolean} addToMailingList */
      async addToWatchlist(addToMailingList) {
        // console.log("addToWatchlist", addToMailingList);
        /** @type {HTMLFormElement | null} */
        const form = this.querySelector(".extended_offer__form");
        if (!form) {
          console.log("Cannot find form element");
          return;
        }
        const isValid = form.checkValidity();

        /** @type {HTMLElement | null} */
        const loading = this.querySelector("#remind-email-loading"); // has to be outside of the callback for scope
        /** @type {HTMLElement | null} */
        const success = this.querySelector("#remind-email-success");
        /** @type {HTMLElement | null} */
        const error = this.querySelector("#remind-email-error");

        if (!loading || !success || !error) {
          console.log("Cannot find neccessary elements");
          return;
        }

        if (!isValid) {
          error.textContent = "Please enter a valid email address.";
          loading.style.display = "none";
          error.style.display = "block";
          return;
        }

        // hide email input
        /** @type {HTMLInputElement | null} */
        const emailAuthInput = this.querySelector("#remind-email-auth-input");
        if (!emailAuthInput) {
          console.log("Cannot find emailAuthInput");
          return;
        }
        emailAuthInput.style.display = "none";

        let email_address = emailAuthInput.value;
        let mailinglist_optin = addToMailingList ? 1 : 0;

        // success callback
        let callbackHandler = function() {
          error.style.display = "none";
          loading.style.display = "none";
          success.style.display = "block";
        };

        // error callback
        /**
         * @param {any} err
         */
        let errorHandler = function(err) {
          if (err.message) {
            error.textContent = err.message;
          }
          loading.style.display = "none";
          error.style.display = "block";
        };

        // show loading animation
        /** @type {HTMLElement | null} */
        const emailAuthLoading = this.querySelector("#remind-email-loading");
        if (!emailAuthLoading) {
          console.log("Cannot find emailAuthLoading element");
          return;
        }
        emailAuthLoading.style.display = "block";

        // Disable submit button
        /** @type {HTMLButtonElement | null} */
        const emailAuthButton = this.querySelector("#remind-email-auth-button");
        if (!emailAuthButton) {
          console.log("Cannot find emailAuthButton");
          return;
        }
        emailAuthButton.disabled = true;

        const payload = `{
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": "${email_address}" 
                  }
                }
              },
              "channels": [
                "EMAIL"
              ]
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": "$shopify:::$default:::${this.variant.id}"

                }
              }
            }
          }
        }`

        // console.log("payload: ", payload);

        if (!this.companyId) {
          console.log("Missing company id, cannot post to Klaviyo...");
          return;
        }

        try {
          const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.companyId}`, {
            method: "POST",
            headers: {
              accept: 'application/vnd.api+json',
              revision: '2024-10-15',
              'content-type': 'application/vnd.api+json'
            },
            body: payload,
          })

          // console.log("res: ", res);
          // console.log("status: ", res.status);
          if (res.status < 300 && res.status >= 200) {
            callbackHandler();
          } else {
            throw new Error("Klaviyo status not in the 200 range.");
          }
        } catch (error) {
          console.log("Error in BIS: ", error);
          errorHandler(error);
        }
      }
    }
  );
}
